import React from 'react';
import { connect } from 'react-redux';
import { Grid, Paper, Typography, withStyles, Button, Divider } from '@material-ui/core';
import GetAppIcon from '@material-ui/icons/GetApp';
import { BackButton } from '../sc-utilities';
import WorkVerifierPC from '../sc-download-page/WorkVerifierPC';
import { styles } from './index';
import WorkVerifierMacOS from '../sc-download-page/WorkVerifierMacOS';

const WorkManual = (props) => {
    const { classes, translations } = props;

    return (
        <Paper className={classes.root}>
            <div className={classes.customToolbar}>
                <div className={classes.tableTitle}>
                    {BackButton(translations, classes.customTooltip)}
                    <Typography className={classes.typography}>
                        {translations['user_manuals'] || 'User Manuals'}
                    </Typography>
                </div>
            </div>

            <Grid container direction="row" className={classes.grid}>
                <WorkVerifierPC classes={classes} translations={translations} />
                <Grid item xs={12} sm={6}>
                    <a
                        href="https://cdn.securaze.icu/download/workverifier/help/Securaze%20WorkVerifier_EN.pdf"
                        download
                        target={'_blank'}
                        rel="noopener noreferrer"
                        className={classes.link}
                    >
                        <Button color={'primary'} variant={'contained'} className={classes.history}>
                            <GetAppIcon /> {translations['work_verifier'] || 'Work Verifier'}
                            {'.pdf'}
                        </Button>
                    </a>
                </Grid>
                {/*<Grid item ms={12} lg={12} container
                    direction="row"
                    justify="space-between"
                    alignItems="baseline"
                    style={{ marginTop: '1rem' }}
                >
                    <Grid item xl={6}>
                        <iframe width="560" height="315" src="https://www.youtube.com/embed/esvoE1aqJx4?si=0GzZtNEbux7EofoZ" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                    </Grid>
                    <Grid item xl={6}>
                        <iframe width="560" height="315" src="https://www.youtube.com/embed/7kKE8-zhw08?si=7OL9ylgOG0DjT6Vu" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                    </Grid>
                </Grid> */}
            </Grid>

            <Divider orientation="vertical" flexItem className={classes.divider} />

            <Grid container direction="row" className={classes.grid}>
                <WorkVerifierMacOS classes={classes} translations={translations} />
                <Grid item xs={12} sm={6}>
                    <a
                        href="https://cdn.securaze.icu/download/workverifier/help/Securaze%20WorkVerifier_EN.pdf"
                        download
                        target={'_blank'}
                        rel="noopener noreferrer"
                        className={classes.link}
                    >
                        <Button color={'primary'} variant={'contained'} className={classes.history}>
                            <GetAppIcon /> {translations['work_verifier'] || 'Work Verifier'}
                            {'.pdf'}
                        </Button>
                    </a>
                </Grid>
                {/* <Grid item ms={12} lg={12} container
                    direction="row"
                    justify="space-between"
                    alignItems="baseline"
                    style={{ marginTop: '1rem' }}
                >
                    <Grid item xl={6}>
                        <iframe width="560" height="315" src="https://www.youtube.com/embed/esvoE1aqJx4?si=0GzZtNEbux7EofoZ" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                    </Grid>
                    <Grid item xl={6}>
                        <iframe width="560" height="315" src="https://www.youtube.com/embed/7kKE8-zhw08?si=7OL9ylgOG0DjT6Vu" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                    </Grid>
                </Grid> */}
            </Grid>
        </Paper>
    );
};

const mapStateToProps = (state) => {
    return {
        translations: state?.translate?.translations?.activeTranslations || {},
    };
};

export default connect(mapStateToProps, null)(withStyles(styles, { withTheme: true })(WorkManual));
